<section>
  <h3 class="headline5-main-title">{{ sectionTexts()?.brokerFeeTitle }}</h3>
  <div class="subtext">
    <p class="body-small">{{ sectionTexts()?.brokerFeeSubtitle }}</p>
    <p class="body-small">{{ feeGST() }}</p>
  </div>
  <pc-input
    [allowDecimal]="true"
    [businessUnit]="BusinessUnit.AU"
    [formControl]="feeInput"
    [InputError]="feeLimitError"
    [inputPlaceholder]="sectionTexts()?.brokerFeePlaceholder || ''"
    [isSalesInput]="true"
    [maxLimit]="10"
    [onlyNumbers]="true"
    (input)="onFeeInput()"
  ></pc-input>
  <pc-gradient-btn
    class="edit-btn"
    [isDisabled]="isFeeChanged()"
    [text]="sectionTexts()?.brokerFeeButton || ''"
    (btnClicked)="updateFee()"
  ></pc-gradient-btn>
</section>
